import { render, staticRenderFns } from "./pbx-settings-page.vue?vue&type=template&id=ea2a039e&"
import script from "./pbx-settings-page.vue?vue&type=script&lang=js&"
export * from "./pbx-settings-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports